module.exports = __webpack_public_path__ + "static/img/button.463fbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/button.png
// module id = l6W8
// module chunks = 1